/* reasons.component.js */

import reasonsController from "./reasons.controller";

/**
 * @desc component for Maintain Reasons
 * @example <maintain-reasons></maintain-reasons>
 */

const maintainReasons = {
    controller: reasonsController,
    controllerAs: 'mrvm',
    templateUrl: '/App/Components/Certifications/maintainReasons/reasons.html'
};

export default maintainReasons;